var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollapse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3 8.3L5.3 14.3C5.1 14.5 5 14.7 5 15C5 15.3 5.1 15.5 5.3 15.7C5.7 16.1 6.3 16.1 6.7 15.7L12 10.4L17.3 15.7C17.7 16.1 18.3 16.1 18.7 15.7C19.1 15.3 19.1 14.7 18.7 14.3L12.7 8.3C12.3 7.9 11.7 7.9 11.3 8.3Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_246_3241",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 8,
    width: 14,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3 8.3L5.3 14.3C5.1 14.5 5 14.7 5 15C5 15.3 5.1 15.5 5.3 15.7C5.7 16.1 6.3 16.1 6.7 15.7L12 10.4L17.3 15.7C17.7 16.1 18.3 16.1 18.7 15.7C19.1 15.3 19.1 14.7 18.7 14.3L12.7 8.3C12.3 7.9 11.7 7.9 11.3 8.3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_246_3241)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(0 -1 -1 0 24 24)",
    fill: "#3B3C43"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.32306aa68cae0e72e7c662177142ef20.svg";
export { ForwardRef as ReactComponent };